import React from 'react';
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';



import './Industries.css';
import fintechImage from '../../img/fintech.webp';
import agricultureImage from '../../img/agriculture.jpg';
import ecommerceImage from '../../img/ecommerce.webp';
import governmentImage from '../../img/government.jpg';
import healthImage from '../../img/healthcare.jpg';
import logisticImage from '../../img/logistic.jpg';
import energyImage from '../../img/energy.jpg';

export default function Industries() {
  const industries = [
    { title: "Fintech",  
      
      
      image: fintechImage },
    { title: "Energy", 
      image: energyImage },
    { title: "Logistic",  
      image: logisticImage },
    { title: "Government",  
      image: governmentImage },
    { title: "Ecommerce", 
      image: ecommerceImage },
    { title: "Agriculture",  
      image: agricultureImage },
    { title: "Healthcare", 
      image: healthImage },
  ];

  return (
    <div className="industry">
  <h1>INDUSTRIES</h1>
  <hr />
  <div className="industries-container">
    <div className="info-section">
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis distinctio magni natus nihil debitis eius omnis ut expedita est eum, quae voluptatum adipisci molestias, quibusdam impedit quod ratione doloribus ducimus tailored to your needs.
      </p>
      <button className="discover-btn">Discover Now</button>
    </div>
    <div className="vertical-line"></div>
    <div className="slider-section"> 
      <Swiper
        spaceBetween={40}
        slidesPerView={3}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        modules={[Autoplay]}
        loop={true}
      >
        {industries.map((industry, index) => (
          <SwiperSlide key={index}>
            <div className="card">
              <img
                src={industry.image}
                alt={industry.title}
                className="card-image"
              />
              <h3>{industry.title}</h3>
              <p>{industry.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </div>
</div>

  );
}
